<template>
  <div class="line-chart chart-container">
    <h3>{{ title }}</h3>
    <v-skeleton-loader
      v-if="isLoading"
      type="image"
      alt="Getting stats..."
    ></v-skeleton-loader>
    <div v-if="chartOptions && chartOptions.xAxis && !isLoading">
      <v-chart
        v-if="chartOptions"
        ref="chartInstance"
        @finished="chartFinished"
        :option="chartOptions"
        style="height: 250px; width: 500px;"
      />
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
} from "echarts/components";

import { LineChart } from "echarts/charts";
use([
  CanvasRenderer,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  LineChart,
  DataZoomComponent,
]);

const EMITTED_ACTIONS = {
  FINISHED: "finished",
};

export default {
  name: "LineGraph",
  props: {
    title: {
      type: String,
      required: false,
    },
    chartData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    chartOptions() {
      return {
        xAxis: {
          type: "category",
          data: this.chartData.xAxis,
          boundaryGap: false,
          axisLabel: {
            color: "white",
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "white",
          },
          minInterval: 1,
          min: 0,
        },
        dataZoom: {
          id: "dataZoomX",
          type: "slider",
          start: 0,
          end: 100,
          filterMode: "filter",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          data: this.getLegend(this.chartData.seriesData),
          icon: "rect",
          textStyle: {
            color: "white",
          },
        },
        series: this.chartData.seriesData,
      };
    },
    isLoading() {
      return !(this.chartData && this.chartData.seriesData);
    },
  },
  methods: {
    chartFinished() {
      this.$emit(EMITTED_ACTIONS.FINISHED, true);
    },
    reloadChart() {
      if (this.$refs.chartInstance) {
        this.$refs.chartInstance.resize();
      }
    },
    getLegend(data) {
      if (!data) {
        return [];
      }
      let ret = [];
      data.forEach((x) => {
        ret.push(x.name);
      });
      return ret;
    },
  },
  watch: {
    refresh: {
      handler() {
        this.reloadChart();
      },
    },
  },
};
</script>

<style scoped>
.line-chart {
  color: #fff;
}
</style>
